<!-- 
*****************************************************************************
**                                                                         **
** Copyright (c) 2012-2024, Tyker Technology BV                            **
** All rights reserved.                                                    **
**                                                                         **
** This software is the confidential and proprietary information of        **
** Tyker Technology BV. Unauthorized copying or disclosure of this file,   **
** via any medium is strictly prohibited. This file is only available to   **
** authorized individuals with the permission of the copyright holders.    **
** If you encounter this file and do not have permission, please contact   ** 
** the copyright holders and delete this file.                             **
**                                                                         **
***************************************************************************** 
-->


<template>
    <v-select
        :value="value"
        :items="units"
        item-text="name"
        item-value="conversionId"
        persistent-hint
        single-line
        return-object
        placeholder="Choose unit"
        @input="$emit('input', $event)"
        dense
        
    >
    <template slot="prepend">
        <v-icon>mdi-ruler</v-icon>
    </template>
        <!-- <template
            slot="selection"
            slot-scope="data"
        >{{ "data.item.name" }}</template>
        <template
            slot="item"
            slot-scope="data"
        >{{ "test" }}</template> -->
    </v-select>
</template>

<script>
export default {
    props: ['value'],
    computed: {
        units: {
            get() {
                console.log(this.$units.all)
                return this.$units.all
            }
        }
    }
}
</script>
